import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { TABS } from "@/data";
import Landing from "@/components/Landing";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Tour from "@/components/Tour";
import Merch from "@/components/Merch";
import Music from "@/components/Music";
import Videos from "@/components/Videos";

const SECTIONS = { TOUR: Tour, MERCH: Merch, MUSIC: Music, VIDEOS: Videos };

const fromHash = () => {
  const h = window.location.hash.replace("#", "").toUpperCase();
  return TABS.includes(h) ? h : null;
};

function App() {
  const [tab, setTab] = useState(fromHash);

  useEffect(() => {
    const onHash = () => setTab(fromHash());
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);

  const go = (next) => {
    window.history.pushState(null, "", next ? `#${next.toLowerCase()}` : window.location.pathname);
    setTab(next);
    window.scrollTo({ top: 0 });
  };

  const Section = tab ? SECTIONS[tab] : null;

  return (
    <div className="bg-black text-white min-h-screen flex flex-col">
      <AnimatePresence mode="wait">
        {!tab ? (
          <motion.div key="landing" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }} className="flex-1 flex flex-col">
            <Landing onSelect={go} />
          </motion.div>
        ) : (
          <motion.div key="site" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }} className="flex-1 flex flex-col">
            <Header active={tab} onSelect={go} />
            <main className="flex-1 px-4 sm:px-8 pb-16">
              <AnimatePresence mode="wait">
                <motion.div key={tab} data-testid={`section-${tab.toLowerCase()}`}
                  initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -8 }} transition={{ duration: 0.3 }}
                  className="max-w-4xl mx-auto">
                  <Section />
                </motion.div>
              </AnimatePresence>
            </main>
            <Footer />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
